import {FooterSection, Header, JoinWaitListForm} from './sections';
import "./sections/style.css";
import ReactGA from "react-ga4";
import {useEffect} from 'react';
import SEO from '../../components/common/SEO';
import {breadcrumbSchema} from '../../utils/structuredData';

const Home = () => {
    useEffect(()=>{
        if(process.env.REACT_APP_ENV === "production") {
            ReactGA.initialize("G-ZB9N7T58NE");
            ReactGA.send({ hitType: "pageview", page: "/", title: "Landing Home Page" });
        }
    },[])

    const breadcrumbs = breadcrumbSchema([
        { name: 'Home', url: '/' },
        { name: 'Book a Demo', url: '/book-a-demo' }
    ]);

    return (
        <div className="min-w-full homePageContainer relative">
            <SEO
                title="Book a Demo - CadencePro.ai | Try AI-Powered Project Management"
                description="Join CadencePro and experience AI-powered project risk management. Book a demo to see real-time simulations, risk analysis, and intelligent capacity planning in action."
                canonical="/book-a-demo"
                keywords="book demo cadencepro, try cadencepro, project management demo, AI project planning trial, schedule demo"
                structuredData={breadcrumbs}
            />
            <Header />
            <JoinWaitListForm />
            <FooterSection />
        </div>
    )
};

export default Home;
